import { createAction } from 'redux-actions';
import * as types from '@src/store/types';

export const addActionsToStash = createAction(types.ADD_ACTIONS_TO_STASH);
export const clearStash = createAction(types.CLEAR_STASH);
